export const FETCH_FAQ_REQUEST = "FETCH_FAQ_REQUEST";
export const ADD_FAQ_REQUEST = "ADD_FAQ_REQUEST";
export const EDIT_FAQ_REQUEST = "EDIT_FAQ_REQUEST";
export const DELETE_FAQ_REQUEST = "DELETE_FAQ_REQUEST";
